import { QP_PAGE_SIZE_VALUE_DEFAULT, QP_PAGE_SIZE_VALUE_MAX } from './queryParamConstants';
import { pageTypeConstants } from './pageTypeConstants';

export const MIN_THIN_PAGE_COUNT = 30;
export const SWIPER_TABLET_TILES_COUNT = 3.5;
export const PAGE_SIZE_OPTIONS = [
    { size: QP_PAGE_SIZE_VALUE_DEFAULT, adLimit: 2 },
    { size: QP_PAGE_SIZE_VALUE_MAX, adLimit: 4 },
];

export const NOT_SUPPORTED_AMP_PAGES = [
    pageTypeConstants.ROOM,
    pageTypeConstants.SEARCH,
    pageTypeConstants.DEALER,
];
